(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["floating-cta"] && !Shopify.designMode) return;
  try {
    
(function () {
  const cta = document.querySelector('[data-floating-cta]');
  if (!cta) return;

  const showAfter = parseInt(cta.dataset.showAfter, 10) || 400;
  let ticking = false;
  let target = null;

  const href = cta.getAttribute('href') || '';
  if (href.startsWith('#')) {
    target = document.querySelector(href);
  }

  function update() {
    const scrolled = window.scrollY > showAfter;
    let nearTarget = false;

    if (target) {
      const rect = target.getBoundingClientRect();
      // Hide once user has reached / passed the target section
      nearTarget = rect.top < window.innerHeight * 0.5 && rect.bottom > 0;
    }

    // Hide near footer
    const doc = document.documentElement;
    const nearBottom = window.scrollY + window.innerHeight > doc.scrollHeight - 200;

    if (scrolled && !nearTarget && !nearBottom) {
      cta.classList.add('is-visible');
    } else {
      cta.classList.remove('is-visible');
    }
    ticking = false;
  }

  window.addEventListener('scroll', function () {
    if (!ticking) {
      window.requestAnimationFrame(update);
      ticking = true;
    }
  }, { passive: true });

  // Smooth scroll for anchor links
  cta.addEventListener('click', function (e) {
    if (target) {
      e.preventDefault();
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  });

  update();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shipping-returns"] && !Shopify.designMode) return;
  try {
    
  (function(){
    'use strict';

    var SHIP_TIMEZONE   = 'Asia/Tokyo';
    var SHIP_UTC_OFFSET = 9;

    // Japanese public holidays. Update yearly.
    var HOLIDAYS = [
      '2026-01-01','2026-01-02','2026-01-03','2026-01-12',
      '2026-02-11','2026-02-23','2026-03-20','2026-04-29',
      '2026-05-03','2026-05-04','2026-05-05','2026-05-06',
      '2026-07-20','2026-08-11','2026-09-21','2026-09-22',
      '2026-10-12','2026-11-03','2026-11-23',
      '2027-01-01','2027-01-02','2027-01-03','2027-01-11',
      '2027-02-11','2027-02-23','2027-03-22','2027-04-29',
      '2027-05-03','2027-05-04','2027-05-05','2027-07-19',
      '2027-08-11','2027-09-20','2027-09-23','2027-10-11',
      '2027-11-03','2027-11-23'
    ];

    var REGION_TIMEZONES = {
      europe:    'Europe/London',
      usa:       'America/New_York',
      australia: 'Australia/Sydney',
      asia:      'Asia/Singapore',
      uae:       'Asia/Dubai'
    };

    function getJSTNow(){
      var f = new Intl.DateTimeFormat('en-CA', {
        timeZone: SHIP_TIMEZONE,
        year:'numeric', month:'2-digit', day:'2-digit',
        hour:'2-digit', minute:'2-digit', second:'2-digit',
        hour12:false
      });
      var o = {};
      f.formatToParts(new Date()).forEach(function(p){ o[p.type] = p.value; });
      var h = parseInt(o.hour, 10); if (h === 24) h = 0;
      return {
        date: o.year + '-' + o.month + '-' + o.day,
        hour: h,
        minute: parseInt(o.minute, 10),
        second: parseInt(o.second, 10)
      };
    }

    function getDayOfWeekOfISO(s){
      var p = s.split('-');
      return new Date(Date.UTC(+p[0], +p[1]-1, +p[2])).getUTCDay();
    }

    function isBusinessDay(s){
      var d = getDayOfWeekOfISO(s);
      if (d === 0 || d === 6) return false;
      if (HOLIDAYS.indexOf(s) !== -1) return false;
      return true;
    }

    function addDaysToISO(s, days){
      var p = s.split('-');
      var t = new Date(Date.UTC(+p[0], +p[1]-1, +p[2]));
      t.setUTCDate(t.getUTCDate() + days);
      return t.getUTCFullYear() + '-' +
             String(t.getUTCMonth()+1).padStart(2,'0') + '-' +
             String(t.getUTCDate()).padStart(2,'0');
    }

    function dispatchMomentUTC(isoDate, cutoffHour){
      var p = isoDate.split('-');
      return new Date(Date.UTC(+p[0], +p[1]-1, +p[2], cutoffHour - SHIP_UTC_OFFSET, 0, 0));
    }

    function calculateShipDate(cutoffHour){
      var jst = getJSTNow();
      if (isBusinessDay(jst.date) && jst.hour < cutoffHour){
        return jst.date;
      }
      var ds = jst.date;
      do { ds = addDaysToISO(ds, 1); } while (!isBusinessDay(ds));
      return ds;
    }

    function formatShipDate(isoDate){
      var p = isoDate.split('-');
      var dt = new Date(Date.UTC(+p[0], +p[1]-1, +p[2], 12, 0, 0));
      return new Intl.DateTimeFormat('en-US', {
        timeZone: SHIP_TIMEZONE, weekday:'long', month:'short', day:'numeric', year:'numeric'
      }).format(dt);
    }

    function formatArrival(utcMoment, tz){
      return new Intl.DateTimeFormat('en-US', {
        timeZone: tz, weekday:'long', month:'short', day:'numeric'
      }).format(utcMoment);
    }

    function nextCutoffEpoch(cutoffHour){
      var jst = getJSTNow();
      var target = (isBusinessDay(jst.date) && jst.hour < cutoffHour)
        ? jst.date
        : (function(){
            var ds = jst.date;
            do { ds = addDaysToISO(ds, 1); } while (!isBusinessDay(ds));
            return ds;
          })();
      return dispatchMomentUTC(target, cutoffHour).getTime();
    }

    function formatCountdown(ms){
      if (ms < 0) ms = 0;
      var totalMin = Math.floor(ms / 60000);
      var hours = Math.floor(totalMin / 60);
      var mins  = totalMin % 60;
      if (hours > 0){
        return hours + (hours === 1 ? ' Hour ' : ' Hours ') +
               mins  + (mins  === 1 ? ' min'  : ' mins');
      }
      return mins + (mins === 1 ? ' min' : ' mins');
    }

    function updateAll(root){
      var cutoffHour = parseInt(root.getAttribute('data-cutoff-hour'), 10) || 10;
      var shipDate   = calculateShipDate(cutoffHour);
      var baseUTC    = dispatchMomentUTC(shipDate, cutoffHour);
      var nowMs      = new Date().getTime();
      var cutoffMs   = nextCutoffEpoch(cutoffHour);

      var cdEl = root.querySelector('[data-shipping-countdown]');
      if (cdEl) cdEl.textContent = formatCountdown(cutoffMs - nowMs);

      var shipEl = root.querySelector('[data-ship-date]');
      if (shipEl) shipEl.textContent = formatShipDate(shipDate);

      Object.keys(REGION_TIMEZONES).forEach(function(key){
        var el = root.querySelector('[data-region="' + key + '"]');
        if (!el) return;
        var transit = parseInt(root.getAttribute('data-transit-' + key), 10);
        if (isNaN(transit)) transit = 2;
        var arrival = new Date(baseUTC.getTime() + transit * 86400000);
        el.textContent = formatArrival(arrival, REGION_TIMEZONES[key]);
      });
    }

    function setupToggle(root){
      var btn  = root.querySelector('[data-toggle-shipping]');
      var body = root.querySelector('.shipping-returns__body');
      if (!btn || !body) return;
      btn.addEventListener('click', function(){
        var expanded = btn.getAttribute('aria-expanded') === 'true';
        btn.setAttribute('aria-expanded', expanded ? 'false' : 'true');
        body.style.display = expanded ? 'none' : '';
      });
    }

    function init(){
      var roots = document.querySelectorAll('[data-shipping-returns]');
      roots.forEach(function(root){
        setupToggle(root);
        try { updateAll(root); } catch (e) { /* no-op */ }
      });
      setInterval(function(){
        document.querySelectorAll('[data-shipping-returns]').forEach(function(root){
          try { updateAll(root); } catch (e) { /* no-op */ }
        });
      }, 30 * 1000);
    }

    if (document.readyState === 'loading'){
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }

    // Re-init on Shopify theme editor events
    document.addEventListener('shopify:section:load', init);
  })();

  } catch(e) { console.error(e); }
})();
})();
